<template>
	<div class="chat-input">
		<textarea
			ref="textarea"
			v-model="text"
			class="chat-input-textarea"
			:placeholder="placeholder"
			rows="1"
			:disabled="disabled"
			@keydown="onKeydown"
			@input="autoResize"
		></textarea>

		<button
			type="button"
			class="chat-input-send"
			:style="sendStyle"
			:disabled="!canSend"
			@click="emitSend"
			:aria-label="disabled ? 'Aguarde a resposta atual...' : 'Enviar mensagem'"
		>
			<v-icon size="20" :color="$corTextoPrimary">{{ disabled ? 'mdi-loading mdi-spin' : 'mdi-send' }}</v-icon>
		</button>
	</div>
</template>

<script>
export default {
	name: 'ChatInput',

	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: 'Pergunte algo sobre seus dados…',
		},
	},

	data() {
		return {
			text: '',
		};
	},

	computed: {
		canSend() {
			return !this.disabled && this.text.trim().length > 0;
		},
		sendStyle() {
			return { background: this.$vuetify?.theme?.themes?.light?.primary };
		},
	},

	methods: {
		autoResize() {
			const el = this.$refs.textarea;
			if (!el) return;
			el.style.height = 'auto';
			el.style.height = Math.min(el.scrollHeight, 160) + 'px';
		},

		onKeydown(event) {
			if (event.key === 'Enter' && !event.shiftKey) {
				event.preventDefault();
				this.emitSend();
			}
		},

		emitSend() {
			if (!this.canSend) return;
			const value = this.text.trim();
			this.text = '';
			this.$nextTick(this.autoResize);
			this.$emit('send', value);
		},

		setText(value) {
			this.text = value;
			this.$nextTick(() => {
				this.autoResize();
				this.$refs.textarea?.focus();
			});
		},
	},
};
</script>

<style scoped>
.chat-input {
	display: flex;
	align-items: flex-end;
	gap: 8px;
	padding: 12px;
	border-top: 1px solid rgba(148, 163, 184, 0.25);
	background: rgba(255, 255, 255, 0.6);
	backdrop-filter: blur(12px);
}

.chat-input-textarea {
	flex: 1;
	min-height: 42px;
	max-height: 160px;
	resize: none;
	border: 1px solid rgba(148, 163, 184, 0.35);
	background: rgba(255, 255, 255, 0.9);
	border-radius: 14px;
	padding: 10px 14px;
	font-size: 14px;
	line-height: 1.5;
	color: #111827;
	font-family: inherit;
	outline: none;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.chat-input-textarea:focus {
	border-color: rgba(var(--color-primary-rgb, 252, 207, 50), 0.7);
	box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb, 252, 207, 50), 0.18);
}

.chat-input-textarea:disabled {
	background: rgba(241, 245, 249, 0.7);
	color: #94a3b8;
}

.chat-input-send {
	flex-shrink: 0;
	width: 42px;
	height: 42px;
	border-radius: 14px;
	border: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: transform 0.15s ease, opacity 0.15s ease, box-shadow 0.15s ease;
	box-shadow: 0 10px 20px -14px rgba(var(--color-primary-rgb, 252, 207, 50), 0.6);
}

.chat-input-send:hover:not(:disabled) {
	transform: translateY(-1px);
}

.chat-input-send:disabled {
	opacity: 0.45;
	cursor: not-allowed;
}
</style>
